import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GestParaComponent } from './components/gest-para/gest-para.component';

const routes: Routes = [
  { path: '', component: GestParaComponent  },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full'  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestParagraphesRoutingModule { }
